import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./NewAsset.css";
import apiClient from "../utils/apiClient";

const AddAsset = () => {
  const navigate = useNavigate();

  const [asset, setAsset] = useState({
    asset_number: "",
    serial_number: "",
    brand: "",
    model: "",
    processor: "",
    ram: "",
    storage: "",
    purchase_date: "",
    warranty_expiry: "",
    vendor: "",
    purchase_cost: "",
    location: "",
    asset_status: "Available",
    remarks: "",
  });

  const handleChange = (e) => {
    setAsset({
      ...asset,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await apiClient("/assetinventory/inventory/add/", {
        method: "POST",
        body: JSON.stringify(asset),
      });
            alert("Asset Added Successfully");

      navigate("/dashboard/ManagerAcess/assetprofile");

    } catch (error) {
      console.error(error);
      alert("Unable to save asset");
    }
  };

  return (
    <div className="addasset-page">

      <div className="addasset-card">

        <div className="addasset-header">
          <h2>Add New Asset</h2>
          <p>Create a new Laptop / Desktop / Device</p>
        </div>

        <form onSubmit={handleSubmit}>

          <h3>Asset Information</h3>

          <div className="addasset-grid">

            <div className="form-group">
            <label>Asset Name *</label>

            <select
                name="asset_name"
                value={asset.asset_name}
                onChange={handleChange}
                required
            >
                <option value="Laptop">Laptop</option>
                <option value="Desktop">Desktop</option>
                <option value="Monitor">Monitor</option>
                <option value="Keyboard">Keyboard</option>
                <option value="Mouse">Mouse</option>
                <option value="Dock">Dock</option>
                <option value="Printer">Printer</option>
                <option value="Other">Other</option>
            </select>
            </div>

            <div className="form-group">
              <label>Asset Number *</label>
              <input
                name="asset_number"
                value={asset.asset_number}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Serial Number *</label>
              <input
                name="serial_number"
                value={asset.serial_number}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Brand *</label>
              <select
                name="brand"
                value={asset.brand}
                onChange={handleChange}
                required
              >
                <option value="">Select</option>
                <option>Dell</option>
                <option>HP</option>
                <option>Lenovo</option>
                <option>Apple</option>
                <option>ASUS</option>
                <option>Acer</option>
                <option>Others</option>
              </select>
            </div>

            <div className="form-group">
              <label>Model *</label>
              <input
                name="model"
                value={asset.model}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Processor</label>
              <input
                name="processor"
                value={asset.processor}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>RAM</label>
              <input
                name="ram"
                value={asset.ram}
                onChange={handleChange}
                placeholder="16 GB"
              />
            </div>

            <div className="form-group">
              <label>Storage</label>
              <input
                name="storage"
                value={asset.storage}
                onChange={handleChange}
                placeholder="512 GB SSD"
              />
            </div>

          </div>

          <h3>Purchase Details</h3>

          <div className="addasset-grid">

            <div className="form-group">
              <label>Purchase Date</label>
              <input
                type="date"
                name="purchase_date"
                value={asset.purchase_date}
                onChange={handleChange}
                required
                />
            </div>

            <div className="form-group">
              <label>Warranty Expiry</label>
              <input
                type="date"
                name="warranty_expiry"
                value={asset.warranty_expiry}
                onChange={handleChange}
                required
                />
            </div>

            <div className="form-group">
              <label>Vendor</label>
              <input
                name="vendor"
                value={asset.vendor}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Purchase Cost</label>
             <input
                type="number"
                min="0"
                step="0.01"
                name="purchase_cost"
                value={asset.purchase_cost}
                onChange={handleChange}
                />
            </div>

          </div>

          <h3>Inventory</h3>

          <div className="addasset-grid">

            <div className="form-group">
              <label>Location</label>
              <input
                name="location"
                value={asset.location}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label>Status</label>
              <select
                name="asset_status"
                value={asset.asset_status}
                onChange={handleChange}
              >
                <option>Available</option>
                <option>Assigned</option>
                <option>Repair</option>
                <option>Damaged</option>
                <option>Scrapped</option>
              </select>
            </div>

          </div>

          <div className="form-group">
            <label>Remarks</label>
            <textarea
              rows="4"
              name="remarks"
              value={asset.remarks}
              onChange={handleChange}
            />
          </div>

          <div className="button-row112">

            <button
              type="button"
              className="cancel-btn112"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="save-btn112"
            >
              Save Asset
            </button>

          </div>

        </form>

      </div>

    </div>
  );
};

export default AddAsset;